
import React from "react";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import { useSettings } from "@/context/SettingsContext";

const JournalEntrySkeleton = () => {
  const { darkMode } = useSettings();
  
  return (
    <Card className={cn(
      "w-full shadow-md border backdrop-blur-sm overflow-hidden",
      darkMode 
        ? "bg-[#2d1a45]/80 border-[#6127A0]/30" 
        : "bg-white/90 border-[#D896A4]/10"
    )}>
      <div className="p-4">
        <div className="flex justify-between items-center mb-3">
          <div className="flex items-center gap-3">
            <Skeleton className="h-8 w-8 rounded-full" />
            <Skeleton className="h-4 w-24" />
          </div>
          <div className="flex gap-2">
            <Skeleton className="h-8 w-20" />
            <Skeleton className="h-8 w-20" />
            <Skeleton className="h-8 w-20" />
          </div>
        </div>
        
        <Skeleton className="h-16 w-full mb-3" />
        
        <div className="mt-3 mb-2">
          <div className="flex gap-1">
            {[...Array(7)].map((_, i) => (
              <Skeleton key={i} className="h-2 w-2 rounded-full" />
            ))}
          </div>
        </div>
        
        <div className="mt-2">
          <Skeleton className="h-3 w-24 mb-1" />
          <Skeleton className="h-4 w-full" />
        </div>
      </div>
    </Card>
  );
};

export default JournalEntrySkeleton;
